import { render, staticRenderFns } from "./PillItem.vue?vue&type=template&id=1a6f2456&"
import script from "./PillItem.vue?vue&type=script&setup=true&lang=js&"
export * from "./PillItem.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PillItem.vue?vue&type=style&index=0&id=1a6f2456&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports